import environments from './environments';

const ADD_MEMBER = 'ADD_MEMBER';
const ACCESS_CODE = 'ACCESS_CODE';
const APPLICATIONS = 'APPLICATIONS';
const ARCHIVE_HOUSEHOLD = 'ARCHIVE_HOUSEHOLD';
const BROKER = 'BROKER';
const COMMUNICATION_PREFERENCES = 'COMMUNICATION_PREFERENCES';
const COMMUNICATION_PREFERENCES_AC = 'COMMUNICATION_PREFERENCES_AC';
const DELEGATION_CONSUMER = 'DELEGATION_CONSUMER';
const DELEGATION_OTHER = 'DELEGATION_OTHER';
const EDE_SEARCH_PAGE = 'EDE_SEARCH_PAGE';
const EDE_ID_PROOFING = 'EDE_ID_PROOFING';
const MEMBER_ENROLLMENT = 'MEMBER_ENROLLMENT';
const MEMBER_ENROLLMENT_LIST = 'MEMBER_ENROLLMENT_LIST';
const MEMBER_ENROLLMENT_LIST_PREMIUM_HISTORY = 'MEMBER_ENROLLMENT_LIST_PREMIUM_HISTORY';
const MEMBER_ENROLLMENT_PREMIUM_HISTORY = 'MEMBER_ENROLLMENT_PREMIUM_HISTORY';
const MEMBER_ENROLLMENT_RECONCILIATION = 'MEMBER_ENROLLMENT_RECONCILIATION';
const FALLBACK = 'FALLBACK';
const HOME = 'HOME';
const INDPORTAL = 'INDPORTAL';
const ISSUER_EDI_TESTING = 'ISSUER_EDI_TESTING';
const ISSUER_EDI_TESTING_TEST_DETAILS = 'ISSUER_EDI_TESTING_TEST_DETAILS';
const IVM = 'IVM';
const IVM_ISSUER_LIST = 'IVM_ISSUER_LIST';
const IVM_ISSUER_PACKET_LIST = 'IVM_ISSUER_PACKET_LIST';
const IVM_ISSUER_REVIEW_STMT = 'IVM_ISSUER_REVIEW_STMT';
const IVM_REVIEW_STMT_CONFIRM = 'IVM_REVIEW_STMT_CONFIRM';
const LCE = 'LCE';
const MULTI_HOUSEHOLD_DETAILS = 'MULTI_HOUSEHOLD_DETAILS';
const NEW_INBOX_HOME = 'NEW_INBOX_HOME';
const PRE_OEP_LANDING = 'PRE_OEP_LANDING';
const PRE_ELIGIBILITY = 'PRE_ELIGIBILITY';
const FORGOT_EMAIL = 'FORGOT_EMAIL';
const PRE_ELIGIBILITY_DISCLAIMER_FROM_HOME = 'PRE_ELIGIBILITY_DISCLAIMER_FROM_HOME';
const PRE_ELIGIBILITY_SCREENING_FROM_HOME_JSP = 'PRE_ELIGIBILITY_SCREENING_FROM_HOME_JSP';
const PRE_ELIGIBILITY_DISCLAIMER_FROM_FLOW = 'PRE_ELIGIBILITY_DISCLAIMER_FROM_FLOW';
const PRE_ELIGIBILITY_DISCLAIMER = 'PRE_ELIGIBILITY_DISCLAIMER';
const PRE_ELIGIBILITY_RESULTS = 'PRE_ELIGIBILITY_RESULTS';
const PRE_ELIGIBILITY_SCREENING_FROM_HOME = 'PRE_ELIGIBILITY_SCREENING_FROM_HOME';
const PRE_ELIGIBILITY_SCREENING = 'PRE_ELIGIBILITY_SCREENING';
const PLAN_SUMMARY = 'PLAN_SUMMARY';
const VIEW_PLAN_INFO = 'VIEW_PLAN_INFO';
const PAYMENT_REDIRECT = 'PAYMENT_REDIRECT';
const PRE_SCREENER = 'PRE_SCREENER';
const SECURE_INBOX = 'SECURE_INBOX';
const ACCOUNT_ACTIVITY = 'ACCOUNT_ACTIVITY';
const SET_HOUSEHOLD = 'SET_HOUSEHOLD';
const SSAP = 'SSAP';
const TICKET_BROKER = 'TICKET_BROKER';
const TICKET_BROKER_CREATE = 'TICKET_BROKER_CREATE';
const TICKET_BROKER_DETAIL = 'TICKET_BROKER_DETAIL';
const TICKET_CONSUMER = 'TICKET_CONSUMER';
const TICKET_CONSUMER_CREATE = 'TICKET_CONSUMER_CREATE';
const TICKET_CONSUMER_DETAIL = 'TICKET_CONSUMER_DETAIL';
const TICKET_MGMT = 'TICKET_MGMT';
const TICKET_MGMT_TYPES = 'TICKET_MGMT_TYPES';
const TICKET_MGMT_EXCHANGE_ASSIGNEES = 'TICKET_MGMT_EXCHANGE_ASSIGNEES';
const TICKET_MGMT_MANAGE_TAGS = 'TICKET_MGMT_MANAGE_TAGS';
const TICKET_MGMT_MANAGE_CUSTOM_FIELDS = 'TICKET_MGMT_MANAGE_CUSTOM_FIELDS';
const TICKET_REPORTS = 'TICKET_REPORTS';
const TICKET_MGMT_MANAGE_WORKGROUP = 'TICKET_MGMT_MANAGE_WORKGROUP';
const MY_ENROLLMENT_HISTORY = 'MY_ENROLLMENT_HISTORY';
const MANAGE_DRUGS = 'MANAGE_DRUGS';
const DYNAMIC_SECURITY_QUESTIONS = 'DYNAMIC_SECURITY_QUESTIONS';
const TICKET_LIST = 'TICKET_LIST';

const TICKET_SEND_MESSAGE = 'TICKET_SEND_MESSAGE';
const TICKET_MGMT_WORKGROUP_TAG_EDIT = 'TICKET_MGMT_WORKGROUP_TAG_EDIT';
const TICKET_MGMT_WORKGROUP_TAG_EDIT_REDIRECT = 'TICKET_MGMT_WORKGROUP_TAG_EDIT_REDIRECT';
const TOBACCO = 'TOBACCO';
const TOBACCO_EXEMPT = 'TOBACCO_EXEMPT';
const VERIFICATION_DOCUMENTS = 'VERIFICATION_DOCUMENTS';
const ELIGIBILITY_RESULTS = 'ELIGIBILITY_RESULTS';
const CRM_SEARCH = 'CRM_SEARCH';
const ENTITY_EXPORT_BOB = 'ENTITY_EXPORT_BOB';
const ENTITY_TRANSFER_BOB = 'ENTITY_TRANSFER_BOB';
const BROKER_CONNECT = 'BROKER_CONNECT';
const BROKER_CONNECT_PARTICIPATION = 'BROKER_CONNECT_PARTICIPATION';
const BROKER_CONNECT_AVAILABILITY = 'BROKER_CONNECT_AVAILABILITY';
const ANON_GA_AGENTS = 'ANON_GA_AGENTS';
const ANON_GA_CARRIERS = 'ANON_GA_CARRIERS';
const ANON_GA_GAEPS = 'ANON_GA_GAEPS';
const CRM_APPLICATION_ELIGIBILITY = 'CRM_APPLICATION_ELIGIBILITY';
const REPORT_DUEDATE_CHARTS = 'REPORT_DUEDATE_CHARTS';
const CUSTOM_GROUPING = 'CUSTOM_GROUPING';

const RIDP = 'RIDP';
const RIDP_CONTACT_INFO = 'RIDP_CONTACT_INFO';
const RIDP_IDENTITY_QUESTION = 'RIDP_IDENTITY_QUESTION';
const RIDP_CALL_EXPERIAN = 'RIDP_CALL_EXPERIAN';
const RIDP_UPLOAD_DOCUMENT = 'RIDP_UPLOAD_DOCUMENT';
const RIDP_UPLOAD_DOCUMENT_PROCESS = 'RIDP_UPLOAD_DOCUMENT_PROCESS';
const RIDP_VERIFICATION_COMPLETE = 'RIDP_VERIFICATION_COMPLETE';
const RIDP_VERIFICATION_REJECTED = 'RIDP_VERIFICATION_REJECTED';
const DMI_VERIFICATIONS = 'DMI_VERIFICATIONS';
const RIDP_TECHNICAL_ERROR = 'RIDP_TECHNICAL_ERROR';
const VIEW_MEMBER_ACCOUNT = 'VIEW_MEMBER_ACCOUNT';
const CAP_APPLICATIONS = 'CAP_APPLICATIONS';
const MEMBER_APP_LIST = 'MEMBER_APP_LIST';
const ADMIN_PROVISION = 'ADMIN_PROVISION';

const TICKET_MGMT_MANAGE_QUEUE = 'TICKET_MGMT_MANAGE_QUEUE';

const RESET_PASSWORD = 'RESET_PASSWORD';
const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';
const ADMIN_SERFF = 'ADMIN_SERFF';
const ADMIN_SERFF_PLANS_LOAD_STATUS = 'ADMIN_SERFF_PLANS_LOAD_STATUS';
const ADMIN_SERFF_TRANSFER_STATUS = 'ADMIN_SERFF_TRANSFER_STATUS';
const LOAD_PLANS = 'LOAD_PLANS';
const LOAD_DRUGS = 'LOAD_DRUGS';

export const devRoutes = {
    /////////Anonymous Flow////////////
    // PreEligibility
    [PRE_OEP_LANDING]: '/open_enrollment_has_not_started_yet',
    [PRE_ELIGIBILITY]: '/preeligibility',
    [FORGOT_EMAIL]: '/forgotEmail',
    [PRE_ELIGIBILITY_DISCLAIMER_FROM_HOME]: '/preeligibility/disclaimer?fromHome=1',
    [PRE_ELIGIBILITY_DISCLAIMER_FROM_FLOW]: '/preeligibility/disclaimer?fromFlow=1',
    [PRE_ELIGIBILITY_DISCLAIMER]: '/preeligibility/disclaimer',
    [PRE_ELIGIBILITY_RESULTS]: '/preeligibility/results',
    [PRE_ELIGIBILITY_SCREENING]: '/preeligibility/preeligibilityscreening',
    [PRE_ELIGIBILITY_SCREENING_FROM_HOME]: '/preeligibility/preeligibilityscreening?fromHome=1',
    [PRE_ELIGIBILITY_SCREENING_FROM_HOME_JSP]: '/preeligibility#/?fromHome=1',
    [PRE_SCREENER]: '/prescreener',

    [ACCESS_CODE]: '/accessCode',
    [COMMUNICATION_PREFERENCES_AC]: '/preferences',
    [CRM_SEARCH]: '/crm_search',
    [DELEGATION_OTHER]: '/delegation',
    [FALLBACK]: '/errorPage',
    [HOME]: '/',
    [LCE]: '/lce',
    [SSAP]: '/ssap',
    [TOBACCO]: '/tobacco',

    // Documents upload for verifications

    [VERIFICATION_DOCUMENTS]: '/mp/documents',

    // Broker Portal.
    [TICKET_BROKER]: '/bp/ticket',
    [TICKET_BROKER_CREATE]: '/bp/ticket/create',
    [TICKET_BROKER_DETAIL]: '/bp/ticket/:id',
    [EDE_ID_PROOFING]: '/bp/idProofing',
    [EDE_SEARCH_PAGE]: '/bp/idProofing/search',

    // Individual Portal (Also called Member Portal) and its nested routes.
    [INDPORTAL]: '/mp',
    [APPLICATIONS]: '/mp/applications',
    [DELEGATION_CONSUMER]: '/mp/delegation',
    [ELIGIBILITY_RESULTS]: '/mp/eligibility',
    [TOBACCO_EXEMPT]: '/mp/additionalinfo',
    [NEW_INBOX_HOME]: '/mp/inbox',
    [COMMUNICATION_PREFERENCES]: '/mp/preferences',

    [TICKET_CONSUMER]: '/mp/ticket',
    [TICKET_CONSUMER_DETAIL]: '/mp/ticket/:id',
    [TICKET_CONSUMER_CREATE]: '/mp/ticket/create',
    [MY_ENROLLMENT_HISTORY]: '/mp/enrollmenthistory',
    [PLAN_SUMMARY]: '/mp/planSummary',
    [VIEW_PLAN_INFO]: '/hix/private/planinfo/:coverageStartDate/:planId',
    [PAYMENT_REDIRECT]: '/hix/indportal/finance/paymentRedirect?finEnrlDataKey=:finEnrlDataKey',
    [MULTI_HOUSEHOLD_DETAILS]: '/mp/multiHouseholdDetails',

    // Admin Portal
    [MANAGE_DRUGS]: '/hix/cap/admin/manageDrugs',

    // Referral
    [DYNAMIC_SECURITY_QUESTIONS]: '/hix/referral/securityquestions',

    // Ticket Management Portal.
    [TICKET_MGMT]: '/ticketManagement',
    [TICKET_MGMT_TYPES]: '/ticketManagement/types',
    [TICKET_MGMT_EXCHANGE_ASSIGNEES]: '/ticketManagement/exchange-assignees',
    [TICKET_MGMT_MANAGE_TAGS]: '/ticketManagement/tags',
    [TICKET_MGMT_MANAGE_CUSTOM_FIELDS]: '/ticketManagement/customFields',
    [TICKET_REPORTS]: '/hix/reports/tickets/due',
    [TICKET_MGMT_MANAGE_WORKGROUP]: '/ticketManagement/manageworkgroup',
    [TICKET_MGMT_WORKGROUP_TAG_EDIT_REDIRECT]: '/ticketManagement/workgroupTag/edit',
    [TICKET_MGMT_MANAGE_QUEUE]: '/ticketmgmt/ticket/managequeue',
    [TICKET_MGMT_WORKGROUP_TAG_EDIT]: '/ticketManagement/workgroupTag/edit/:id',
    [TICKET_SEND_MESSAGE]: '/ticketManagement/sendMessage',

    //entity export bob
    [ENTITY_EXPORT_BOB]: '/entity/export',
    [ENTITY_TRANSFER_BOB]: '/entity/transferBOB/:id/:type',

    [BROKER_CONNECT]: '/broker/helpondemand',
    [BROKER_CONNECT_PARTICIPATION]: '/broker/helpondemand/participation',
    [BROKER_CONNECT_AVAILABILITY]: '/broker/helpondemand/availability',

    //GAEP
    [ANON_GA_AGENTS]: '/agents',
    [ANON_GA_CARRIERS]: '/carriers',
    [ANON_GA_GAEPS]: '/gaeps',

    //Archive Household
    [ARCHIVE_HOUSEHOLD]: '/archive-hh',

    //Secure Inbox
    [SECURE_INBOX]: '/secure-inbox',

    // Account Activity
    [ACCOUNT_ACTIVITY]: '/account-activity/:id',
    //Issuer EDI Testing
    [ISSUER_EDI_TESTING]: '/issuer-edi-testing/:id',
    [ISSUER_EDI_TESTING_TEST_DETAILS]: '/issuer-edi-testing/details/:id',

    //Invoicing Management
    [IVM]: '/ivm',
    [IVM_ISSUER_LIST]: '/ivm/issuerList',
    [IVM_ISSUER_PACKET_LIST]: '/ivm/packetList',
    [IVM_ISSUER_REVIEW_STMT]: '/ivm/reviewstatememt',
    [IVM_REVIEW_STMT_CONFIRM]: '/ivm/reviewstatememt/confirm',
    //CRM Application Eligibiliity
    [CRM_APPLICATION_ELIGIBILITY]: '/application/eligibility',

    //Reports
    [REPORT_DUEDATE_CHARTS]: '/reports/tickets/due',

    //Custom Grouping
    [CUSTOM_GROUPING]: '/mp/customGrouping',
    [SET_HOUSEHOLD]: 'private/setHousehold/',

    //Ridp
    [RIDP]: '/ridp',
    [RIDP_CONTACT_INFO]: '/ridp/contactInfo',
    [RIDP_IDENTITY_QUESTION]: '/ridp/identityQuestions',
    [RIDP_CALL_EXPERIAN]: '/ridp/identitynotverify',
    [RIDP_UPLOAD_DOCUMENT]: '/ridp/uploaddocument',
    [RIDP_UPLOAD_DOCUMENT_PROCESS]: '/ridp/uploaddocumentprocess',
    [RIDP_VERIFICATION_COMPLETE]: '/ridp/verificationComplete',
    [RIDP_VERIFICATION_REJECTED]: '/ridp/verification',
    [RIDP_TECHNICAL_ERROR]: '/ridp/technicalerror',
    //member
    [ADD_MEMBER]: '/member/addmember',
    [VIEW_MEMBER_ACCOUNT]: 'crm/consumer/dashboard',

    // DMI verifications
    [DMI_VERIFICATIONS]: '/dmi/verifications',

    //Member Portal
    [ADD_MEMBER]: '/member/addMember',
    [MEMBER_ENROLLMENT]: '/cap/member/enrollment',
    [MEMBER_ENROLLMENT_LIST]: '/cap/member/enrollment/:id',
    [MEMBER_ENROLLMENT_LIST_PREMIUM_HISTORY]: '/cap/member/enrollment/:id/premiumhistory',
    [MEMBER_ENROLLMENT_PREMIUM_HISTORY]: '/cap/member/enrollment/premiumhistory/:eId',
    [MEMBER_ENROLLMENT_RECONCILIATION]: '/cap/enrollmentreconciliation/enrollmentmonthlyactivity/search',

    // Cap Applications
    [CAP_APPLICATIONS]: '/cap/member/applications/:id',
    [MEMBER_APP_LIST]: '/cap/member/applications',

    // Admin Provision
    [ADMIN_PROVISION]: '/admin/provision',

    //reset password
    [RESET_PASSWORD]: '/cap/member/reset-password',
    [RESET_PASSWORD_SUCCESS]: '/cap/member/reset-password/success',

    // Admin  serffStatus
    [ADMIN_SERFF]: '/hix/cap/admin/serff',
    [ADMIN_SERFF_PLANS_LOAD_STATUS]: '/hix/cap/admin/serff/serffPlansLoadStatus',
    [ADMIN_SERFF_TRANSFER_STATUS]: '/hix/cap/admin/serff/serffTransferStatus',

    // Admin Load Plans and Drugs
    [LOAD_PLANS]: '/cap/admin/serff/loadPlans',
    [LOAD_DRUGS]: '/cap/admin/serff/loadDrugs',
    [TICKET_LIST]: '/cap/ticketList',
};

export const prodRoutes = {
    /////////Anonymous Flow////////////
    // PreEligibility
    [PRE_ELIGIBILITY_SCREENING_FROM_HOME_JSP]: '/hix/preeligibility#/?fromHome=1',
    [PRE_ELIGIBILITY_DISCLAIMER_FROM_HOME]: '/hix/preeligibility/disclaimer?fromHome=1',
    [PRE_ELIGIBILITY_DISCLAIMER_FROM_FLOW]: '/hix/preeligibility/disclaimer?fromFlow=1',
    [PRE_ELIGIBILITY_DISCLAIMER]: '/hix/preeligibility/disclaimer',
    [PRE_ELIGIBILITY_RESULTS]: '/hix/preeligibility/results',
    [PRE_ELIGIBILITY_SCREENING_FROM_HOME]: '/hix/preeligibility/preeligibilityscreening?fromHome=1',
    [PRE_ELIGIBILITY_SCREENING]: '/hix/preeligibility/preeligibilityscreening',
    [PRE_ELIGIBILITY]: '/hix/preeligibility',
    [FORGOT_EMAIL]: '/hix/forgotEmail',
    [PRE_SCREENER]: '/prescreener',

    [PRE_OEP_LANDING]: '/hix/open_enrollment_has_not_started_yet',
    [ACCESS_CODE]: '/hix/accessCode',
    [COMMUNICATION_PREFERENCES_AC]: '/hix/preferences',
    [CRM_SEARCH]: '/hix/crm/membersearch/screenpop',
    [DELEGATION_OTHER]: '/hix/delegation',
    [FALLBACK]: '/hix/anonymous/errorPage',
    [HOME]: '/hix/',
    [LCE]: '/hix/lce',
    [MULTI_HOUSEHOLD_DETAILS]: '/hix/mp?showMultiHH=true',
    [SSAP]: '/hix/newssap/start',
    [TOBACCO]: '/hix/tobacco',

    // Documents upload for verifications

    [VERIFICATION_DOCUMENTS]: '/hix/qle/documents',

    // Broker Portal.
    [BROKER]: '/hix/broker',
    [EDE_ID_PROOFING]: '/hix/bp/idProofing',
    [EDE_SEARCH_PAGE]: '/hix/bp/idProofing/search',
    [TICKET_BROKER]: '/hix/bp/ticket',
    [TICKET_BROKER_CREATE]: '/hix/bp/ticket/create',
    [TICKET_BROKER_DETAIL]: '/hix/bp/ticket/:id',
    [BROKER_CONNECT]: '/hix/broker/helpondemand',
    [BROKER_CONNECT_PARTICIPATION]: '/hix/broker/helpondemand/participation',
    [BROKER_CONNECT_AVAILABILITY]: '/hix/broker/helpondemand/availability',

    // Individual Portal (Also called Member Portal) and its nested routes.
    [INDPORTAL]: '/hix/mp',
    [APPLICATIONS]: '/hix/mp/applications',
    [DELEGATION_CONSUMER]: '/hix/mp/delegation',
    [ELIGIBILITY_RESULTS]: '/hix/mp/eligibility',
    [TOBACCO_EXEMPT]: '/hix/mp/additionalinfo',
    [NEW_INBOX_HOME]: '/hix/mp/inbox',
    [COMMUNICATION_PREFERENCES]: '/hix/mp/preferences',
    [TICKET_CONSUMER]: '/hix/mp/ticket',
    [TICKET_CONSUMER_DETAIL]: '/hix/mp/ticket/:id',
    [TICKET_CONSUMER_CREATE]: '/hix/mp/ticket/create',
    [MY_ENROLLMENT_HISTORY]: '/hix/mp/enrollmenthistory',
    [PLAN_SUMMARY]: '/hix/mp/applications/planSummary',
    [VIEW_PLAN_INFO]: '/hix/private/planinfo/:coverageStartDate/:planId',
    [PAYMENT_REDIRECT]: '/hix/indportal/finance/paymentRedirect?finEnrlDataKey=:finEnrlDataKey',

    // Admin Portal
    [MANAGE_DRUGS]:'/hix/cap/admin/manageDrugs',

    // Referral
    [DYNAMIC_SECURITY_QUESTIONS]: '/hix/referral/securityquestions',

    // Ticket Management Portal.
    [TICKET_MGMT]: '/hix/ticketManagement',
    [TICKET_MGMT_TYPES]: '/hix/ticketManagement/types',
    [TICKET_MGMT_EXCHANGE_ASSIGNEES]: '/hix/ticketManagement/exchange-assignees',
    [TICKET_MGMT_MANAGE_TAGS]: '/hix/ticketManagement/tags',
    [TICKET_MGMT_MANAGE_CUSTOM_FIELDS]: '/hix/ticketManagement/customFields',
    [TICKET_REPORTS]: '/hix/reports/tickets/due',
    [TICKET_SEND_MESSAGE]: '/hix/ticketManagement/ticket/ticketdetail/:id/sendMessage',
    [TICKET_SEND_MESSAGE]: '/hix/ticketManagement/ticket/ticketdetail/:id/sendMessage',
    [TICKET_MGMT_WORKGROUP_TAG_EDIT]: '/hix/ticketManagement/workgroupTag/edit/:id',

    //entity export bob
    [ENTITY_EXPORT_BOB]: '/hix/entity/export',
    [ENTITY_TRANSFER_BOB]: '/hix/entity/transferBOB/:id/:type',

    //GAEP
    [ANON_GA_AGENTS]: '/hix/agents',
    [ANON_GA_CARRIERS]: '/hix/carriers',
    [ANON_GA_GAEPS]: '/hix/gaeps',

    //Archive Household
    [ARCHIVE_HOUSEHOLD]: '/hix/household/archivehousehold',

    //Issuer EDI Testing
    [ISSUER_EDI_TESTING]: '/hix/issuer-edi-testing/:id',
    [ISSUER_EDI_TESTING_TEST_DETAILS]: '/hix/issuer-edi-testing/details/:id',

    //Secure Inbox
    [SECURE_INBOX]: '/hix/crm/secure-inbox',

    // Account Activity
    [ACCOUNT_ACTIVITY]: '/hix/cap/member/account-activity/:id',

    //Invoicing Management
    [IVM]: '/hix/ivm',
    [IVM_ISSUER_LIST]: '/hix/ivm/issuerList',
    [IVM_ISSUER_PACKET_LIST]: '/hix/ivm/packetList',
    [IVM_ISSUER_REVIEW_STMT]: '/hix/ivm/reviewstatememt',
    [IVM_REVIEW_STMT_CONFIRM]: '/hix/ivm/reviewstatememt/confirm',

    //CRM Application Eligibiliity
    [CRM_APPLICATION_ELIGIBILITY]: '/hix/crm/application/eligibility',

    //Reports
    [REPORT_DUEDATE_CHARTS]: '/hix/reports/tickets/due',

    //Custom Grouping
    [CUSTOM_GROUPING]: '/hix/mp/customGrouping',
    [SET_HOUSEHOLD]: '/hix/private/setHousehold/',

    //Ridp
    [RIDP]: '/hix/ridp',
    [RIDP_CONTACT_INFO]: '/hix/ridp/contactInfo',
    [RIDP_IDENTITY_QUESTION]: '/hix/ridp/identityQuestions',
    [RIDP_CALL_EXPERIAN]: '/hix/ridp/identitynotverify',
    [RIDP_UPLOAD_DOCUMENT]: '/hix/ridp/uploaddocument',
    [RIDP_VERIFICATION_COMPLETE]: '/hix/ridp/verificationComplete',
    [RIDP_VERIFICATION_REJECTED]: '/hix/ridp/verification',
    [RIDP_TECHNICAL_ERROR]: '/hix/ridp/technicalerror',
    [RIDP_UPLOAD_DOCUMENT_PROCESS]: '/hix/ridp/uploaddocumentprocess',
    //member
    [ADD_MEMBER]: '/hix/member/addmember',
    [VIEW_MEMBER_ACCOUNT]: 'crm/consumer/dashboard',

    // DMI verifications
    [DMI_VERIFICATIONS]: '/hix/dmi/verifications',

    //Member Portal
    [ADD_MEMBER]: '/hix/member/addMember',
    [MEMBER_ENROLLMENT]: '/hix/cap/member/enrollment',
    [MEMBER_ENROLLMENT_LIST]: '/hix/cap/member/enrollment/:id',
    [MEMBER_ENROLLMENT_LIST_PREMIUM_HISTORY]: '/hix/cap/member/enrollment/:id/premiumhistory',
    [MEMBER_ENROLLMENT_PREMIUM_HISTORY]: '/hix/cap/member/enrollment/premiumhistory/:eId',
    [MEMBER_ENROLLMENT_RECONCILIATION]: '/cap/enrollmentreconciliation/enrollmentmonthlyactivity/search',

    // Cap Applications
    [CAP_APPLICATIONS]: '/hix/cap/member/applications/:id',
    [MEMBER_APP_LIST]: '/hix/cap/member/applications',
    [TICKET_LIST]: '/hix/cap/ticketList',

    // Mangeworkgroup
    [TICKET_MGMT_MANAGE_WORKGROUP]: '/hix/ticketManagement/manageworkgroup',
    [TICKET_MGMT_MANAGE_QUEUE]: 'hix/ticketmgmt/ticket/managequeue',
    // Admin Provision
    [ADMIN_PROVISION]: '/hix/admin/provision',
    // Admin  serffPlansLoadStatus 
    [ADMIN_SERFF]: '/hix/cap/admin/serff',
    [ADMIN_SERFF_PLANS_LOAD_STATUS]: '/hix/cap/admin/serff/serffPlansLoadStatus',
    [ADMIN_SERFF_TRANSFER_STATUS]: '/hix/cap/admin/serff/serffTransferStatus',

    //reset password
    [RESET_PASSWORD]: '/hix/cap/member/reset-password',
    [RESET_PASSWORD_SUCCESS]: '/hix/cap/member/reset-password/success',

    // Admin  serffPlansLoadStatus
    [ADMIN_SERFF]: '/hix/cap/admin/serff',
    [ADMIN_SERFF_PLANS_LOAD_STATUS]: '/hix/cap/admin/serff/serffPlansLoadStatus',
    [ADMIN_SERFF_TRANSFER_STATUS]: '/hix/cap/admin/serff/serffTransferStatus',

    // Admin Load Plans and Drugs
    [LOAD_PLANS]: '/hix/cap/admin/serff/loadPlans',
    [LOAD_DRUGS]: '/hix/cap/admin/serff/loadDrugs',
    [TICKET_MGMT_MANAGE_QUEUE]: '/hix/ticketmgmt/ticket/managequeue',
    [TICKET_MGMT_WORKGROUP_TAG_EDIT_REDIRECT]: '/hix/ticketManagement/workgroupTag/edit',
};

export const customRoutes = {
    /////////Anonymous Flow////////////
    // PreEligibility
    [FORGOT_EMAIL]: '/forgotEmail',
    [PRE_SCREENER]: '/prescreener',

    [PRE_OEP_LANDING]: '/hix/open_enrollment_has_not_started_yet',
    [HOME]: '/',
    [ACCESS_CODE]: '/accessCode',
    [EDE_ID_PROOFING]: '/bp/idProofing',
    [EDE_SEARCH_PAGE]: '/bp/idProofing/search',
    [FALLBACK]: '/errorPage',
    [INDPORTAL]: '/mp',
    [TOBACCO_EXEMPT]: '/mp/additionalinfo',
    [COMMUNICATION_PREFERENCES]: '/preferences',
    [DELEGATION_CONSUMER]: '/mp_delegation',
    [DELEGATION_OTHER]: '/delegation',
    [MULTI_HOUSEHOLD_DETAILS]: '/mp/multiHouseholdDetails',
    [LCE]: '/lce',
    [SSAP]: '/ssap',
    [MY_ENROLLMENT_HISTORY]: '/mp/enrollmenthistory',
    [TICKET_BROKER]: '/hix/broker/ticket',
    [TICKET_BROKER_CREATE]: '/hix/bp/ticket/create',
    [TICKET_BROKER_DETAIL]: '/hix/bp/ticket/:id',
    [TICKET_CONSUMER]: '/mp_ticket',
    [TICKET_CONSUMER_CREATE]: '/hix/mp/ticket/create',
    [TICKET_CONSUMER_DETAIL]: '/hix/mp/ticket/:id',
    [TOBACCO]: '/tobacco',
    //admin
    [MANAGE_DRUGS]: '/hix/cap/admin/manageDrugs',
    //entity export bob
    [ENTITY_EXPORT_BOB]: '/hix/entity/export',
    [ENTITY_TRANSFER_BOB]: '/hix/entity/transferBOB/:id/:type',
    [BROKER_CONNECT_PARTICIPATION]: '/participation',
    [BROKER_CONNECT_AVAILABILITY]: '/availability',
    //Invoicing Management
    [IVM_ISSUER_LIST]: '/hix/ivm/issuerList/:userId',
    [IVM_ISSUER_PACKET_LIST]: '/hix/ivm/packetList',
    [IVM_ISSUER_REVIEW_STMT]: '/hix/ivm/reviewstatememt',
    [IVM_REVIEW_STMT_CONFIRM]: '/hix/ivm/reviewstatememt/confirm',

    //Reports
    [REPORT_DUEDATE_CHARTS]: '/hix/reports/tickets/due',

    //Custom Grouping
    [CUSTOM_GROUPING]: '/mp/customGrouping',
    [SET_HOUSEHOLD]: '/private/setHousehold/',

    //Ridp
    [RIDP]: '/ridp',
    [RIDP_CONTACT_INFO]: '/ridp/contactInfo',
    [RIDP_IDENTITY_QUESTION]: '/ridp/identityQuestions',
    [RIDP_CALL_EXPERIAN]: '/ridp/identitynotverify',
    [RIDP_UPLOAD_DOCUMENT]: '/ridp/uploaddocument',
    [RIDP_UPLOAD_DOCUMENT_PROCESS]: '/ridp/uploaddocumentprocess',
    [RIDP_VERIFICATION_COMPLETE]: '/ridp/verificationComplete',
    [RIDP_VERIFICATION_REJECTED]: '/ridp/verification',
    [RIDP_TECHNICAL_ERROR]: '/ridp/technicalerror',

    // DMI verifications
    [DMI_VERIFICATIONS]: '/dmi/verifications',

    //Member Portal
    [ADD_MEMBER]: '/hix/member/addMember',
    [MEMBER_ENROLLMENT]: '/hix/cap/member/enrollment',
    [MEMBER_ENROLLMENT_LIST]: '/hix/cap/member/enrollment/:id',
    [MEMBER_ENROLLMENT_LIST_PREMIUM_HISTORY]: '/hix/cap/member/enrollment/:id/premiumhistory',
    [MEMBER_ENROLLMENT_PREMIUM_HISTORY]: '/hix/cap/member/enrollment/premiumhistory/:eId',
    [MEMBER_ENROLLMENT_RECONCILIATION]: '/cap/enrollmentreconciliation/enrollmentmonthlyactivity/search',

    // Cap Applications
    [CAP_APPLICATIONS]: '/hix/cap/member/applications/:id',
    [MEMBER_APP_LIST]: '/hix/cap/member/applications',
    [TICKET_LIST]: '/hix/cap/ticketList',

    // Admin Provision
    [ADMIN_PROVISION]: '/hix/admin/provision',

    // Manage Workgroup
    [TICKET_MGMT_MANAGE_WORKGROUP]: '/hix/ticketManagement/manageworkgroup',
    [TICKET_MGMT_MANAGE_QUEUE]: '/hix/ticketmgmt/ticket/managequeue',
    [TICKET_MGMT_WORKGROUP_TAG_EDIT_REDIRECT]: '/hix/ticketManagement/workgroupTag/edit',

    // Ticket Management
    [TICKET_MGMT_WORKGROUP_TAG_EDIT]: '/hix/ticketManagement/workgroupTag/edit/:id',
    
    // Admin  serffPlansLoadStatus 
    [ADMIN_SERFF]: '/hix/cap/admin/serff',
    [ADMIN_SERFF_PLANS_LOAD_STATUS]: '/hix/cap/admin/serff/serffPlansLoadStatus',
    [ADMIN_SERFF_TRANSFER_STATUS]: '/hix/cap/admin/serff/serffTransferStatus',

    //reset password
    [RESET_PASSWORD]: '/hix/cap/member/reset-password',
    [RESET_PASSWORD_SUCCESS]: '/hix/cap/member/reset-password/success',

    // Admin  serffPlansLoadStatus
    [ADMIN_SERFF]: '/hix/cap/admin/serff',
    [ADMIN_SERFF_PLANS_LOAD_STATUS]: '/hix/cap/admin/serff/serffPlansLoadStatus',
    [ADMIN_SERFF_TRANSFER_STATUS]: '/hix/cap/admin/serff/serffTransferStatus',

    // Admin Load Plans and Drugs
    [LOAD_PLANS]: '/hix/cap/admin/serff/loadPlans',
    [LOAD_DRUGS]: '/hix/cap/admin/serff/loadDrugs',
};

export default {
    [environments.PRODUCTION]: prodRoutes,
    [environments.DEVELOPMENT]: devRoutes,
    [environments.CUSTOM]: customRoutes,
};
